import { SVGProps } from "react";

const TrashcanIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 16, height = 20, fill = "black" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_1151_58" fill="white">
        <path d="M3 20C1.89543 20 1 19.1046 1 18V6H15V18C15 19.1046 14.1046 20 13 20H3Z" />
        <path d="M1 2C0.447715 2 0 2.44772 0 3V4H16V3C16 2.44772 15.5523 2 15 2H12L11.5528 1.10557C11.214 0.428005 10.5215 0 9.76393 0H6.23607C5.47852 0 4.786 0.428004 4.44721 1.10557L4 2H1Z" />
      </mask>
      <path
        d="M4 3H12V1H4V3ZM1 6V4H-1V6H1ZM15 6H17V4H15V6ZM0 4H-2V6H0V4ZM16 4V6H18V4H16ZM4 2V4H5.23607L5.78885 2.89443L4 2ZM12 2L10.2111 2.89443L10.7639 4H12V2ZM-1 6V18H3V6H-1ZM3 22H13V18H3V22ZM17 18V6H13V18H17ZM15 4H1V8H15V4ZM2 4V3H-2V4H2ZM14 3V4H18V3H14ZM16 2H0V6H16V2ZM1 4H4V0H1V4ZM5.78885 2.89443L6.23607 2L2.65836 0.211145L2.21115 1.10557L5.78885 2.89443ZM6.23607 2H9.76393V-2H6.23607V2ZM12 4H15V0H12V4ZM9.76393 2L10.2111 2.89443L13.7889 1.10557L13.3416 0.211146L9.76393 2ZM9.76393 2V2L13.3416 0.211146C12.6641 -1.14399 11.279 -2 9.76393 -2V2ZM6.23607 2V2V-2C4.72098 -2 3.33593 -1.14399 2.65836 0.211145L6.23607 2ZM2 3C2 3.55228 1.55228 4 1 4V0C-0.656854 0 -2 1.34315 -2 3H2ZM13 22C15.2091 22 17 20.2091 17 18H13V22ZM18 3C18 1.34315 16.6569 0 15 0V4C14.4477 4 14 3.55228 14 3H18ZM-1 18C-1 20.2091 0.790861 22 3 22V18H-1Z"
        fill={fill}
        mask="url(#path-1-inside-1_1151_58)"
      />
    </svg>
  );
};

export default TrashcanIcon;
